<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-association" ref="associationRef">
    <!--查找关联多选  -->
    <template v-if="ppf.fieldType == 25 && Array.isArray(ppf.fieldValue) && ppf.fieldValue?.length > 1">
      <template v-if="ppf.sourceType == 1">
        <jw-overflow-list :min="1">
          <div v-for="fv in ppf?.fieldValue" :key="fv.value" class="overflow-content">
            <ly-association :value="fv" :entity="fv?.business" :mask="needMask"></ly-association>
          </div>
          <template #overflow="{ number }">
            <div @mouseover="handleChange" class="association-more-mouseover">
              <jw-tag ref="associationTagRef" size="small" class="hand" @mouseover="mouseoverTag">+{{ number }}</jw-tag>
              <div ref="popupRef" class="association-more" :style="{ top: '22px', left: popupLeft - popupTagLeft + 'px', width: popupWidth }" v-if="ppf.fieldType == 25 && ppf.fieldValue?.length > 1">
                <div class="association-more-item" v-for="fv in ppf?.fieldValue" :key="fv.value">
                  <ly-association :value="fv" :entity="fv?.business" :is-link="true" :mask="needMask"></ly-association>
                </div>
              </div>
            </div>
          </template>
        </jw-overflow-list>
      </template>
      <template v-else>
        <div class="association-list">
          <div v-for="item in ppf?.fieldValue" :key="item.value" style="display: inline-block" class="association-item">
            <ly-association :value="item" :entity="item?.business" :defaultShow="true" :mask="true"></ly-association>
          </div>
        </div>
      </template>
    </template>
    <!-- 查找关联单选 -->
    <template v-else>
      <ly-association :value="gfv" :entity="gfv?.business" :mask="needMask"></ly-association>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
});
const ppf = computed(() => props.params);

const needMask = computed(() => {
  if (ppf.value.isAssTable) {
    return true;
  } else if (ppf.value.sourceType == 1) {
    return ppf.value.mask;
  } else {
    return true;
  }
});
// 计算属性：判断 fieldValue 是否为长度为 1 的数组
const isSingleArray = computed(() => Array.isArray(ppf.value.fieldValue) && ppf.value.fieldValue.length === 1);
// 动态计算 fieldValue 的值
const gfv = computed(() => {
  if (isSingleArray.value) {
    return ppf.value.fieldValue[0];
  } else {
    return ppf.value.fieldValue;
  }
});

const popupLeft = ref(0);
const popupTagLeft = ref(0);
const popupWidth = ref(0);
const associationRef = ref(null);
const associationTagRef = ref(null);
const popupRef = ref(null);

const mouseoverTag = () => {
  const rectTag = associationTagRef.value?.$el.getBoundingClientRect();
  popupTagLeft.value = rectTag.left;
};

const handleChange = () => {
  const rect = associationRef.value.getBoundingClientRect();
  popupLeft.value = rect.left;
  popupWidth.value = rect.width + 'px';
};
</script>
<style scoped lang="less">
@import './association.less';
</style>
